console.log("REACT_APP_URL:", process.env.REACT_APP_URL);
console.log("Full redirect URI:", process.env.REACT_APP_URL + '/auth/callback');


const getClientId = () => {
  const hostname = window.location.hostname;
  const clientIds = {
        'tlv.bp.com': '95ca5bf7-adc8-46e4-a596-a029753a8135'                           // Production
  };
  return clientIds[hostname] || '44610ba7-318c-45f4-b6d1-8a4b3aa03888'; // fallback
};
export const msalConfig = {
  auth: {
    clientId: getClientId(),
    authority: "https://login.microsoftonline.com/ea80952e-a476-42d4-aaf4-5457852b0f7e",
    redirectUri: process.env.REACT_APP_URL + '/auth/callback',
    postLogoutRedirectUri: process.env.REACT_APP_URL,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case "Error":
            console.error(message);
            return;
          case "Info":
            console.info(message);
            return;
          case "Verbose":
            console.debug(message);
            return;
          case "Warning":
            console.warn(message);
            return;
        }
      }
    }
  }
};

// Scopes configuration
export const scopeConfig = {
  // Basic authentication scopes
  basic: ["openid", "profile", "email"],
  // Group reading permissions
  groups: ["Group.Read.All"],
  // Combined scopes for full authentication
  get all() {
    return [...this.basic, ...this.groups];
  }
};

// Login request configuration
export const loginRequest = {
  scopes: scopeConfig.all,
  redirectUri: process.env.REACT_APP_URL + "/auth/callback",
  responseMode: "query"
};


// Backend API configuration
export const backendConfig = {
  baseUrl: process.env.REACT_APP_URL,
  endpoints: {
    pdiLogin: "/auth/PdiLogin",
    sessionInfo: "/api/SessionInfo",
    logout: "/auth/Logout"
  },
  // Get full URL for an endpoint
  getUrl: function(endpoint) {
    return this.baseUrl + this.endpoints[endpoint];
  }
};


// Application configuration
export const appConfig = {
  // Error messages
  errorMessages: {
    missingAuthHeader: "Missing or invalid authorization header",
    invalidToken: "Invalid Microsoft token",
    userNotInGroup: "Access denied: You are not authorized to access this application",
    groupValidationFailed: "Failed to validate user group membership",
    authenticationFailed: "Authentication failed",
    tokenAcquisitionFailed: "Failed to acquire access token",
    backendError: "Backend authentication failed"
  }
};

// Environment-specific settings
export const environmentConfig = {
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // Logging levels
  get logLevel() {
    return this.isDevelopment ? "Verbose" : "Error";
  },
  
  // Debug settings
  get enableDebugLogs() {
    return this.isDevelopment;
  }
};

// Export all configurations
const config = {
  msal: msalConfig,
  login: loginRequest,
  scopes: scopeConfig,
  backend: backendConfig,
  app: appConfig,
  environment: environmentConfig
};

export default config;